<script>
export default {
    type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        // caption: "Split of visitors by Channels",
                        // placevaluesinside: "1",
                        // showvalues: "1",
                        // plottooltext:
                        //     "<b>$dataValue</b> $seriesName Pada $label",
                        theme: "fusion",
                        caption: "JUMLAH HASIL HUTAN",
                        // xAxisname: "Month",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        // numberPrefix: "$",
                        sNumberSuffix: "%",
                        // sYAxisMaxValue: "300",
                    },
                    categories: [
                        {
                            category: [
                                {
                                    label: "April 2022",
                                },
                                {
                                    label: "April 2021",
                                },
                                {
                                    label: "April 2020",
                                },
                            ],
                        },
                    ],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: "27508020.00" },
                                { value: "25435020.00" },
                                { value: "24940040.00" },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: "3825  343.85" },
                                { value: "6710166.22" },
                                { value: "1963935.77" },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {
                                    value: "13.91",
                                },
                                {
                                    value: "26.38",
                                },
                                {
                                    value: "7.87",
                                },
                            ],
                        },
                    ],
                },
};
</script>
